export function getURLMainDomain() {
  const splitByDot = window.location.hostname.split('.');
  const length = splitByDot.length;
  const domainName = `${splitByDot[length-2]}.${splitByDot[length-1]}`;
  return domainName;
}

export function getURLDomain() {
  const splitByDot = window.location.hostname.split('.');
  const newArray = splitByDot.slice(1);
  const domainName = newArray.join('.');

  return domainName;
}

export function getApiGateway(): string | undefined {
  const isLocal = process.env.NODE_ENV === 'development';
  if (isLocal) {
    return process.env.REACT_APP_API_GETWAY;
  } else {
    const URLDomain = getURLDomain();
    return `https://api.${URLDomain}`;
  }
}